<!-- src/components/Navbar.vue -->
<template>
    <section id="topbar">
		<div class="container d-flex justify-content-center justify-content-md-between py-2">
			<div class="logo">
				<a href="#"><img src="/assets/images/logo.png" alt="image" height="60"/></a>
			</div>
			<div class="d-flex">
				<a href="#" class="d-flex ml-2" data-bs-toggle="dropdown" aria-expanded="false">
					<span><i class="fa-solid fa-earth-americas"></i></span>
				</a>
				<ul class="dropdown-menu dropdown-menu-lg-end text-small">
					<li><a class="dropdown-item" @click="setLocale('en')">Ingles</a></li>
					<li><a class="dropdown-item" @click="setLocale('pt_BR')">Portugues</a></li>
				</ul>
				<a href="#" class="d-flex ml-2" data-bs-toggle="dropdown" aria-expanded="false">
          <span><i class="fa-solid fa-circle-half-stroke"></i></span>
        </a>
        <ul class="dropdown-menu dropdown-menu-end shadow" aria-labelledby="bd-theme-text">
          <li>
            <button
              type="button"
              class="dropdown-item d-flex align-items-center"
              data-bs-theme-value="light"
              aria-pressed="false"
              @click="setTheme('light')"
            >
              <i class="fa-regular fa-moon"></i> Claro
            </button>
          </li>
          <li>
            <button
              type="button"
              class="dropdown-item d-flex align-items-center"
              data-bs-theme-value="dark"
              aria-pressed="false"
              @click="setTheme('dark')"
            >
              <i class="fa-solid fa-moon"></i> Escuro
            </button>
          </li>
          <li>
            <button
              type="button"
              class="dropdown-item d-flex align-items-center"
              data-bs-theme-value="auto"
              aria-pressed="true"
              @click="setTheme('auto')"
            >
              <i class="fa-solid fa-circle-half-stroke"></i> Auto
            </button>
          </li>
        </ul>
			</div>
		</div>
	</section>
  </template>
  
<script>
	import { useI18n } from 'vue-i18n';

	export default {
		setup() {
		const { locale } = useI18n();

		// Função para alterar o idioma
		const setLocale = (newLocale) => {
			locale.value = newLocale; // Atualiza o idioma no Vue I18n
			localStorage.setItem('locale', newLocale); // Salva o idioma no localStorage
		};

		// Função para alterar o tema
		const setTheme = (theme) => {
			document.documentElement.setAttribute('data-bs-theme', theme);
			localStorage.setItem('theme', theme); // Salva o tema no localStorage
		};

		// Recupera idioma e tema ao carregar o componente
		const loadPreferences = () => {
		const savedLocale = localStorage.getItem('locale');
		const savedTheme = localStorage.getItem('theme');

		if (savedLocale) {
			locale.value = savedLocale; // Define o idioma salvo
		} else {
			// Detecta idioma do navegador e ajusta
			const browserLocale = navigator.language || navigator.languages[0];
			const supportedLocales = ['en', 'pt-BR', 'es'];
			locale.value = supportedLocales.includes(browserLocale)
				? browserLocale
				: 'pt-BR'; // Fallback para pt-BR
		}

			if (savedTheme) {
				document.documentElement.setAttribute('data-bs-theme', savedTheme);
			} else {
				document.documentElement.setAttribute('data-bs-theme', 'auto'); // Fallback para auto
			}
		};

			loadPreferences();

			return {
				setLocale,
				setTheme,
			};
		},
	};
</script>